export default [
  '_id',
  'type',
  'field',
  'displayType',
  'columnType',
  'width',
  'height',
  'x',
  'y',
  'format',
  'condition',
  'targetValue',
  'targetValueDisplayType',
  'customTrueTargetDisplayValue',
  'customFalseTargetDisplayValue',
  'invertBooleanCondition',
  'rowIndex',
  'column',
  'primaryDisplayOnly',
  'primaryMaxWidth',
  'primaryMaxHeight',
  'columnTitleFontSize',
  'columnTitleFontColor',
  'columnTitleFontStyle',
  'columnTitleFontWeight',
  'columnTitleTextAlign',
  'columnTitleTextTransform',
  'columnTitleTextDecoration',
  'columnTitleBackgroundColor',
  'columnTitlePadding',
  'columnTitleTextOverflow',
  'titleDisplay',
  'titleFontSize',
  'titleFontColor',
  'titleFontStyle',
  'titleFontWeight',
  'titleTextAlign',
  'titleTextTransform',
  'titleTextDecoration',
  'lineHeight',
  'fontSize',
  'fontColor',
  'fontStyle',
  'fontWeight',
  'textAlign',
  'textTransform',
  'textDecoration',
  'textOverflow',
  'padding',
  'margin',
  'borderColor',
  'borderRadius',
  'borderWidth',
  'backgroundColor',
  'zIndex',

  //Special renamed properties to prevent conflict with field properties
  'fieldPositionSchema', //Actual is "schema" 
  'fieldPositionTableColumns', //Actual is "tableColumns"
];
